
function SearchComponent(documentScope) {
    for (let searchComponent of documentScope.querySelectorAll('form[data-search-api][data-search-results]')) {
        let searchApi = searchComponent.getAttribute('data-search-api');
        let searchResultsId = searchComponent.getAttribute('data-search-results');
        searchComponent.addEventListener('submit', function(event) {
            let searchResultsElement = document.getElementById(searchResultsId);
            let searchUrl = new URL(searchApi, window.location.origin);
            let searchParameters = new URLSearchParams(new FormData(searchComponent));
            if (event.submitter.hasAttribute('name')) {
                searchParameters.set(event.submitter.getAttribute('name'), event.submitter.getAttribute('value'));
            }
            let endpoint;
            if (searchComponent.hasAttribute('action')) {
                endpoint = new URL(searchComponent.getAttribute('action'), window.location);
            }
            else {
                endpoint = window.location;
            }
            let hash = endpoint.hash;
            window.history.pushState(null, '', new URL(`?${searchParameters}${hash}`, endpoint));
            if (searchComponent.hasAttribute('data-search-properties')) {
                let searchProperties = new URLSearchParams(searchComponent.getAttribute('data-search-properties'));
                searchParameters = new URLSearchParams([...searchParameters, ...searchProperties]);
            }
            searchUrl.search = searchParameters;
            fetch(searchUrl)
                .then(function(response) {
                    return response.text();
                }).then(function(text) {
                    Array.prototype.map.call(searchResultsElement.children, function(replaced) {
                        let { offsetTop, offsetLeft, offsetWidth, offsetHeight } = replaced;
                        let keyframes = [
                            {
                                position: 'absolute',
                                top: `${offsetTop}px`,
                                left: `${offsetLeft}px`,
                                width: `${offsetWidth}px`,
                                height: `${offsetHeight}px`,
                                opacity: '1',
                                pointerEvents: 'none'
                            },
                            {
                                position: 'absolute',
                                top: `${offsetTop}px`,
                                left: `${offsetLeft}px`,
                                width: `${offsetWidth}px`,
                                height: `${offsetHeight}px`,
                                opacity: '0',
                                pointerEvents: 'none',
                            },
                        ];
                        return [replaced, keyframes];
                    }).map(function([replaced, keyframes]) {
                        let animation = replaced.animate(keyframes, { duration: 300, easing: 'ease' });
                        animation.addEventListener('finish', function() {
                            let scrollTop = window.scrollY;
                            replaced.remove();
                            window.scrollTo({ top: scrollTop, behaviour: 'instant' });
                        });
                    });
                    let document = new DOMParser().parseFromString(text, 'text/html');
                    SearchComponent(document);
                    for (let replacement of Array.from(document.body.children)) {
                        searchResultsElement.appendChild(replacement);
                        replacement.animate([
                            { opacity: '0' },
                            { opacity: '1' },
                        ], { duration: 300, easing: 'ease' });
                    }
                });
            event.preventDefault();
        });
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
        SearchComponent(document);
    });
}
else {
    SearchComponent(document);
}
